/**
 * D-49 (ADR-0034): a bill-wise register rounds its tax item by item, so a bill
 * can be a few paise off taxable × rate. Within a rupee it passes — and the
 * difference is said on the row, never absorbed in silence.
 */
export function taxRoundingWords(paise: number): string {
  const rupees = (Math.abs(paise) / 100).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `tax ${paise < 0 ? 'under' : 'over'} by ₹${rupees} (rounded by the bill)`
}
